const initState = {
    isLoading: false,
    data: null,
    error: null,
  };
  
  const CustomerReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_CUSTOMER_LOADING":
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case "SET_CUSTOMER_DATA":
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      case "SET_CUSTOMER_ERROR":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default CustomerReducer;